module.exports = __webpack_public_path__ + "static/media/hamburger-sprite.9b324355.svg";